<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("project.project_config_date_format") }}
        </h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group required">
              <label>{{ $t("project.optional_date_format") }}</label>
              <select v-model="dateOption" class="form-control">
                <option
                  v-for="dateOption in dateOptions"
                  v-bind:value="dateOption.format"
                  :key="dateOption.id"
                  >{{ dateOption.format }}</option
                >
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("project.project_config_invoice_template") }}
        </h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group required">
              <label>{{ $t("project.optional_invoice_template") }}</label>
              <select v-model="invoiceSelected" class="form-control">
                <option
                  v-for="item in invoiceOptions"
                  v-bind:value="item.id"
                  :key="item.id"
                  >{{ item.text }}</option
                >
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t("project.project_config_bcc_email") }}
        </h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="">{{ $t("project.optional_bcc_email") }}</label>
              <input
                type="email"
                class="form-control"
                :placeholder="$t('common.email')"
                v-model="bccEmail"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          @click="showMessDate()"
          style="margin-right: 5px;"
          v-if="has_perm('update_project_setting') || GET_ACCOUNT_DATA.id == 1"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </div>

    <div class="modal fade" id="modal-projectDate">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("ProjectGeneralSettings.project_seting_title") }}
            </h4>
          </div>
          <div class="modal-body">
            {{ $t("ProjectGeneralSettings.project_seting_msg") }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="saveDateOption"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import constantsData from "@/lib/constantsData";
import InvoiceTemplateEnum from "@/enum/invoiceTemplateEnum"
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";

export default {
  name: "ProjectInvoiceOptions",
  data() {
    return {
      dateOption: constantsData.dateOptionList[0].format,
      dateOptions: constantsData.dateOptionList,
      invoiceOptions: constantsData.invoiceTemplateList,
      invoiceSelected: InvoiceTemplateEnum.REPUBLIC_PALAZA,
      bccEmail: null,
      isLoading: false
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_INFORMATION_PROJECT",
      "UPDATE_INFORMATION_PROJECT",
      "GET_SNACK_BAR",
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    showMessDate() {
      $("#modal-projectDate").modal("show");
    },
    saveDateOption: function() {
      $("#modal-projectDate").modal("hide");
      this.waitingLoading(true);
      const filter = {
        id: utils.getProjectSession(),
        date_view_options: this.dateOption,
        invoice_template: this.invoiceSelected,
        bcc_email: this.bccEmail
      };
      this.UPDATE_INFORMATION_PROJECT(filter)
        .then(
          function() {
            this.SUCCESS_TOAST();
            sessionStorage.setItem('projectDateViewOptions', this.dateOption)
            sessionStorage.setItem('invoiceTemplate', this.invoiceSelected)
            this.waitingLoading(false);
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
            this.waitingLoading(false);
          }.bind(this)
        );
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    }
  },
  mounted() {
    this.GET_INFORMATION_PROJECT({ id: utils.getProjectSession() }).then(
      function(res) {
        let data = res.data
        this.dateOption = data.date_view_options
        this.invoiceSelected = data.invoice_template
        this.bccEmail = data.bcc_email
        this.SUCCESS_TOAST();
      }.bind(this)
    )
    .catch(
      function() {
        this.ERROR_TOAST();
      }.bind(this)
    );
    // this.dateOption = utils.getSessionKeyString('projectDateViewOptions', constantsData.dateOptionList[0].format)
    // this.invoiceSelected = utils.getSessionKeyInt('invoiceTemplate', InvoiceTemplateEnum.REPUBLIC_PALAZA)
  },
  components: {
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/views/Project/ProjectInvoiceOptions.vue